import Nouislider from "nouislider-react";
import drop3 from '../../sounds/drop3.mp3';
import wNumb from 'wnumb';

let slidersTouched = [];

const RangeSliderRow = ({ setCollectResponses, setAllComplete, qData, category, rowId }) => {

  const onRangeUpdate = (setAllComplete, qData, index, category) => (render, handle, value, un, percent) => {
    //console.log(render, handle, value, un, percent);
    //console.log(category.text + ' value:' + Math.round(value[0] * 100) / 100);
    // save response...
    let response = {
      [category.text]: Math.round(value[0] * 100) / 100
    }
    setCollectResponses(current => [...current, response]);

    // push the slider index into an array (if its not already in the array)
    if (!slidersTouched.includes(index)) {
      slidersTouched.push(index); // count how many the user has interacted with
    }

    // then if array.length = categories.length, show the button
    if (slidersTouched.length == qData.categories.length) {
      setAllComplete(true);
    }

    //console.log('number of slidersTouched:' + slidersTouched.length);

    // play a sound
    let audio = new Audio(drop3);
    audio.volume = 0.75;
    audio.play();

  }


  const statingPosition = (qData.max.value - qData.min.value) / 2;

  return (
    <>
      <div className="text-center text-xs md:text-base font-black pt-6 pb-2">{category.text}</div>
      <div className="mb-12">
        <Nouislider
          accessibility
          connect={[true, false]}
          key={rowId}
          id={rowId}
          start={statingPosition}
          tooltips={[wNumb({ decimals: 1 })]}
          range={{
            min: qData.min.value,
            max: qData.max.value
          }}
          step={qData.step}
          pips={{
            mode: 'steps',
            density: 10
          }}
          onSet={onRangeUpdate(setAllComplete, qData, rowId, category)}
        />
      </div>
    </>
  );
}

export default RangeSliderRow;
